const Macy = require('macy');

export default class artistpage {
   constructor(){
      const par = this;

      if(window.innerWidth < 786) {
         let settings = {
            alignVert: false, // if true, textFit will align vertically using css tables
            alignHoriz: false, // if true, textFit will set text-align: center
            multiLine: true, // if true, textFit will not set white-space: no-wrap
            detectMultiLine: true, // disable to turn off automatic multi-line sensing
            minFontSize: 6,
            maxFontSize: 36,
            reProcess: true, // if true, textFit will re-process already-fit nodes. Set to 'false' for better performance
            widthOnly: true, // if true, textFit will fit text to element width, regardless of text height
            alignVertWithFlexbox: false, // if true, textFit will use flexbox for vertical alignment
        };
        
        $(window).on('load pageshow', function(){
         setTimeout(function(){
            textFit($('h1.title').get(0), settings);
         }, 1);
        });

         setTimeout(function(){
            textFit($('h1.title').get(0), settings);
         }, 100);

         $(window).on('resize', function(){
            textFit($('h1.title').get(0), settings);
         });
      }

      if($('.promos--thumbs').length > 0) {
         var macy = Macy({
            container: '.promos--thumbs',
            trueOrder: false,
            waitForImages: true,
            margin: remToPx(1),
            columns: 2,
            breakAt: {
               //  1200: 2,
               //  940: 2,
               520: 2,
               //  400: 1
            }
         });
      }
      
      $('.videos iframe').each(function(){
         $(this).parent().addClass('vid-wrap');
      });

     
      $('.artist-jumplinks--link').off('click').on('click', function(e){
         e.preventDefault();
         e.stopPropagation();
          console.log('click');
         var el = $(this).attr('data-href');
         var top = $(el).offset().top - remToPx(5);
          console.log(top);
         $('html').stop().animate({
            'scrollTop' : top
         }, 20);
      });
   }
}